import { Action, createReducer, on } from '@ngrx/store';

import { LoginResponse } from '@offconon/core-api';

import * as DomainUserActions from './domain-user.actions';

export const DOMAIN_USER_FEATURE_KEY = 'domainUser';

export interface DomainUserState {
  loginResponse: LoginResponse | null;
  user_token: string | null;
  loading: boolean;
  error: any;
}

export const initialDomainUserState: DomainUserState = {
  loginResponse: null,
  user_token: null,
  loading: false,
  error: null,
};

const reducer = createReducer(
  initialDomainUserState,

  on(DomainUserActions.domainUserLogin, (state) => ({
    ...state,
    loading: true,
    error: null,
  })),

  on(DomainUserActions.domainUserLoginSuccess, (state, { loginResponse }) => ({
    ...state,
    loginResponse,
    user_token: loginResponse.jwt_token ?? null,
    loading: false,
    error: null,
  })),

  on(DomainUserActions.domainUserLoginFailure, (state, { error }) => ({
    ...state,
    loading: false,
    error,
  })),

  on(DomainUserActions.domainUserLogout, () => ({
    ...initialDomainUserState,
  })),

  on(DomainUserActions.domainUserSetToken, (state, { user_token }) => ({
    ...state,
    user_token,
  })),

  on(DomainUserActions.loadGuestTokenSuccess, (state, { user_token }) => ({
    ...state,
    user_token,
  })),
);

export function domainUserReducer(
  state: DomainUserState | undefined,
  action: Action,
): DomainUserState {
  return reducer(state, action);
}
